export const categoryMenuItemMenuText = "Tab";
export default {categoryMenuItemMenuText};